var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "avue-sidebar" },
    [
      _c("logo"),
      _c(
        "el-scrollbar",
        { staticStyle: { height: "100%" } },
        [
          _c(
            "el-menu",
            {
              attrs: {
                collapse: _vm.keyCollapse,
                "default-active": _vm.nowTagValue,
                "show-timeout": 200,
                mode: "vertical",
                "unique-opened": "",
              },
            },
            [
              _c("sidebar-item", {
                attrs: {
                  collapse: _vm.keyCollapse,
                  menu: _vm.menu,
                  props: _vm.website.menu.props,
                  screen: _vm.screen,
                  first: "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }